import { FooterLink } from '../components';
import { Route } from './route';

export const footerLinksLeft: FooterLink[] = [
  { href: Route.ABOUTUS, label: 'About Us' },
  { href: Route.REVIEWS, label: 'Reviews' },
  { href: Route.HELP, label: 'Help & Contact' },
];

export const footerLinksRight: FooterLink[] = [
  { href: Route.BLOG, label: 'Blog' },
  { href: Route.VISIONARIES, label: 'Visionaries' },
  { href: Route.DOCTORS, label: 'For Doctors' },
];

export const footerDesktopLinksLeft: FooterLink[] = [
  { href: Route.ABOUTUS, label: 'About Us' },
  { href: Route.REVIEWS, label: 'Reviews' },
];

export const footerDesktopLinksMiddle: FooterLink[] = [
  { href: Route.VISIONARIES, label: 'Visionaries' },
  { href: Route.DOCTORS, label: 'For Doctors' },
];

export const footerDesktopLinksRight: FooterLink[] = [
  { href: Route.HELP, label: 'Help & Contact' },
  { href: Route.BLOG, label: 'Blog' },
];
